module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('home-footer-left')], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('home-footer-right')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61ad0664!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/footer/HomeFooterInfo.vue
// module id = 151
// module chunks = 1